import { useMutation } from "@apollo/client";
import { Button } from "../../../../../../../components/ui";
import { DELETE_CONDITION } from "../../../../../../../graphql/mutation/Condition";

const DeleteCondition = props => {
  const { closeModal, id } = props;
  const [deleteCondition, { loading, error }] = useMutation(
    DELETE_CONDITION(),
    {
      refetchQueries: ["fetchConditionsV2"],
    },
  );

  const handleDelete = async () => {
    await deleteCondition({
      variables: {
        input: { id },
      },
      update: (cache, { data }) => {
        const { deleteCondition: { success } = {} } = data;
        if (success) {
          cache.evict({
            id: cache.identify({
              __typename: "Condition",
              id,
            }),
          });
        }
      },
    });

    closeModal();
  };

  return (
    <div className="mt-4 flex-row justify-center">
      {error && <div className="font-bold">{error.message}</div>}
      <Button
        className="mr-3"
        label="Cancel"
        onClick={() => {
          closeModal();
        }}
      />
      <Button
        label={loading ? "Deleting" : "Delete"}
        disabled={loading}
        action="primary"
        onClick={handleDelete}
      />
    </div>
  );
};

export default DeleteCondition;
